<template>
      <div>
          <pie-chart />
      </div>
</template>

<script>

    import PieChart from "../../components/Charts/Pie";
    export default {
        name: "testchart.vue",
        components: {
            // PieChart
            PieChart
            /*       BarChart,*/
            // LineChart,
            // PieChart
        },
    }
</script>

<style scoped>

</style>
